import { render } from "./MyMore.vue?vue&type=template&id=3f33195c&scoped=true"
import script from "./MyMore.vue?vue&type=script&lang=js"
export * from "./MyMore.vue?vue&type=script&lang=js"

import "./MyMore.vue?vue&type=style&index=0&id=3f33195c&lang=scss&scoped=true"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f33195c"]])

export default __exports__